<script setup>
import { ref } from "vue";
import { useForm } from "@inertiajs/vue3";
import ActionSection from "../../../Jetstream/ActionSection.vue";
import ConfirmationModal from "../../../Jetstream/ConfirmationModal.vue";
import DangerButton from "../../../Jetstream/DangerButton.vue";
import SecondaryButton from "../../../Jetstream/SecondaryButton.vue";

const props = defineProps({
    team: Object,
});

const confirmingTeamDeletion = ref(false);
const form = useForm();

const confirmTeamDeletion = () => {
    confirmingTeamDeletion.value = true;
};

const deleteTeam = () => {
    form.delete(route("teams.destroy", props.team), {
        errorBag: "deleteTeam",
    });
};
</script>

<template>
    <ActionSection>
        <template #title>{{ $t("teams.delete_team.title") }}</template>

        <template #description>{{
            $t("teams.delete_team.description")
        }}</template>

        <template #content>
            <div class="max-w-xl text-sm text-iron-600">
                {{ $t("teams.delete_team.long_description") }}
            </div>

            <div class="mt-5">
                <DangerButton @click="confirmTeamDeletion">
                    {{ $t("teams.delete_team.title") }}
                </DangerButton>
            </div>

            <!-- Delete Team Confirmation Modal -->
            <ConfirmationModal
                :show="confirmingTeamDeletion"
                @close="confirmingTeamDeletion = false"
            >
                <template #title>{{ $t("teams.delete_team.title") }}</template>

                <template #content>
                    {{ $t("teams.delete_team.confirmation") }}
                </template>

                <template #footer>
                    <SecondaryButton @click="confirmingTeamDeletion = false">
                        {{ $t("cancel") }}
                    </SecondaryButton>

                    <DangerButton
                        class="ml-3"
                        :class="{ 'opacity-25': form.processing }"
                        :disabled="form.processing"
                        @click="deleteTeam"
                    >
                        {{ $t("teams.delete_team.title") }}
                    </DangerButton>
                </template>
            </ConfirmationModal>
        </template>
    </ActionSection>
</template>
